<template>
	<section class="search-keywords">
		<table class="search-keywords__table">
			<tbody>
				<tr class="search-keywords__table__tr">
					<th class="search-keywords__table__th">신규 키워드</th>

					<td class="search-keywords__table__td">
						<label>
							<input
								type="text"
								@keypress.enter="addKeyword"
								v-model="newKeyword"
							/>
						</label>
						<p
							class="search-keywords__table__error-message"
							v-if="errorMessage"
						>
							{{ errorMessage }}
						</p>
					</td>

					<td class="search-keywords__table__td">
						<button
							@click="addKeyword"
							class="btn blue search-keywords__button"
						>
							등록
						</button>
					</td>
				</tr>
			</tbody>
		</table>

		<div class="search-keywords__keywords">
			<CheckboxList
				v-model="keywordsEnabled"
				:checkboxList="searchKeywords"
				:girdColumn="5"
				@change="toggleKeywordEnabled($event)"
			/>
		</div>

		<h2 class="search-keywords__header">{{ categoryNames }}</h2>

		<div class="search-keywords__keyword-buttons">
			<span
				class="search-keywords__keyword-button"
				:key="keyword.idKeyword"
				v-for="keyword in keywordButtons"
			>
				<span>{{ keyword.keywordText }}</span>
				<button
					@click="unCheckingKeyword(keyword)"
					class="search-keywords__uncheck-keyword"
				>
					<i class="fas fa fa-times"></i>
				</button>
			</span>
		</div>
	</section>
</template>
<script>
	import _ from 'lodash';
	import CheckboxList from '@/components/CheckboxList';

	export default {
		name: 'CategoryModifySearchKeywords',
		data() {
			return {
				searchKeywords: [],
				keywordsEnabled: [],
				keywordButtons: [],
				keywordsOrigin: [],
				result: {
					insertIdKeywords: [],
					deleteIdKeywords: [],
				},
				newKeyword: '',
				errorMessage: null,
			};
		},
		created() {
			this.initKeywords();
		},

		components: {
			CheckboxList,
		},

		computed: {
			categoryNamesArray() {
				// 단계별 카테고리 이름을 배열로 반환
				// ex) ['스킨케어', '로션']
				return this.$store.getters['category/getSelectedCategoryNames'];
			},
			categoryNames() {
				// 단계별 카테고리 이름을 문자열로 반환
				// ex) 스킨케어 > 로션
				const names = this.categoryNamesArray;

				if (names.length === 0) {
					return '-';
				} else {
					return this.$store.getters[
						'category/getSelectedCategoryNames'
					].join(' > ');
				}
			},
		},
		methods: {
			initKeywords() {
				this.$store.commit('toggleSpinner', true);
				const current = this.$store.state.category.selection;
				const levels = {
					category1st: 1,
					category2nd: 2,
					category3rd: 3,
				};

				this.$axiosAdmin2
					.get(
						`api/categories/level/${levels[current.depth]}/category/${current.id}/search-keywords`
					)
					.then(({ data }) => {
						this.keywordsEnabled = [];
						this.keywordButtons = [];
						this.searchKeywords = [];
						this.newKeyword = '';

						_.each(data.data, item => {
							if (!!item.checked) {
								this.keywordsEnabled.push(item.idKeyword);
								this.keywordButtons.push(item);
							}
						});

						this.keywordsOrigin = _.cloneDeep(this.keywordsEnabled);
						this.searchKeywords = data.data.map(item => {
							return {
								...item,
								id: item.idKeyword,
								value: item.keywordText,
							};
						});
					})
					.finally(() => {
						this.$store.commit('toggleSpinner', false);
					});
			},
			add() {
				const current = this.$store.state.category.selection;
				const levels = {
					category1st: 1,
					category2nd: 2,
					category3rd: 3,
				};
				const newSearchKeywords = [];

				_.each(this.keywordButtons, keyword => {
					newSearchKeywords.push(keyword.keywordText);
				});

				this.$store.commit('category/refreshSearchKeywords', {
					value: newSearchKeywords.sort().join(','),
				});

				this.$axiosAdmin2
					.post(
						`/api/categories/level/${levels[current.depth]}/category/${current.id}/search-keywords`,
						this.result
					)
					.then(({ data }) => {
						alert('변경되었습니다.');
						this.close();
					})
					.catch(({ response }) => {
						console.error(response);
						alert(
							'변경중 문제가 발생하였습니다.\n 계속 발생할 경우 관리자에게 문의하세요.'
						);
					})
					.finally(() => {
						this.$store.commit('toggleSpinner', false);
					});
			},
			close() {
				this.$store.commit('modal/toggleModal', false);
				this.$store.commit('toggleSpinner', false);
			},
			modifyResult(keyword, value) {
				const isOrigin = this.keywordsOrigin.indexOf(keyword.idKeyword);

				if (!!value) {
					const deleteIndex = this.result.deleteIdKeywords.indexOf(
						keyword.idKeyword
					);

					if (deleteIndex > -1) {
						this.result.deleteIdKeywords.splice(deleteIndex, 1);
					}

					if (isOrigin === -1) {
						this.result.insertIdKeywords.push(keyword.idKeyword);
					}
				} else {
					const insertIndex = this.result.insertIdKeywords.indexOf(
						keyword.idKeyword
					);

					if (insertIndex > -1) {
						this.result.insertIdKeywords.splice(insertIndex, 1);
					}

					if (isOrigin > -1) {
						this.result.deleteIdKeywords.push(keyword.idKeyword);
					}
				}
			},
			toggleKeywordEnabled(event) {
				const keyword = this.searchKeywords.find(
					item => item.idKeyword === event
				);
				keyword.checked = !keyword.checked;

				if (!!keyword.checked) {
					this.keywordButtons.push(keyword);
					this.modifyResult(keyword, true);
				} else {
					this.unCheckingKeyword(keyword);
				}
			},
			unCheckingKeyword(keyword) {
				const buttonIndex = _.findIndex(this.keywordButtons, {
					idKeyword: Number(keyword.idKeyword),
				});
				const keywordIndex = _.indexOf(
					this.keywordsEnabled,
					Number(keyword.idKeyword)
				);

				if (buttonIndex !== -1) {
					this.keywordButtons.splice(buttonIndex, 1);
				}

				if (keywordIndex !== -1) {
					this.keywordsEnabled.splice(keywordIndex, 1);
				}

				this.modifyResult(keyword, false);
			},
			addKeyword() {
				const params = { keywordText: this.newKeyword, isDisplay: 1 };
				this.$axiosAdmin2
					.post('/api/common/keyword', params)
					.then(res => {
						alert(`키워드 등록: ${this.newKeyword}`);
						this.initKeywords();
					});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.search-keywords__table {
		table-layout: fixed;
		border-collapse: collapse;
		border-bottom: solid 1px #ebebed;
		margin-bottom: 1em;
	}

	.search-keywords__table__th {
		vertical-align: middle;
		text-align: center;
		background: #f4f7fa;
	}

	.search-keywords__table__td {
		vertical-align: middle;
		text-align: center;
	}

	.search-keywords__button {
		margin: auto;
	}

	.search-keywords__header {
		margin-bottom: 0.5em;
		font-size: 1.5em;
		font-weight: bold;
		color: #303643;
	}

	.search-keywords__keyword-buttons {
		margin-bottom: 2em;
		max-height: 120px;
		overflow-x: auto;
	}

	.search-keywords__keyword-button {
		display: inline-block;
		padding: 1em;
		margin: 0 1em 1em 0;
		background: $btn-blue;
		color: #fff;
		font-weight: bold;
		border-radius: 2em;

		span {
			vertical-align: bottom;
		}
	}

	.search-keywords__keywords {
		line-height: 2em;
		height: 200px;
		overflow-x: hidden;
		overflow-y: auto;
		border: 1px solid #303643;
		border-radius: 4px;
		margin-bottom: 2em;
		padding: 1.5em;
	}

	.search-keywords__keywords-label {
		font-size: 1rem;
		cursor: pointer;
	}

	.search-keywords__table__error-message {
		margin: 1em 0;
		color: $red;
	}

	.search-keywords__keywords-label {
		display: inline-block;
	}
</style>
